import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type AssetMode } from '../types';
import META from './useTrackAssetModeSwitched.meta';

export type UseTrackAssetModeSwitchedParams = {
  asset_mode: AssetMode;
  quick_tool?: string;
  source?: 'asset_modal_quick_tools' | 'asset_modal_versions_menu';
};

export const useTrackAssetModeSwitched = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetModeSwitched = useCallback(
    (params: UseTrackAssetModeSwitchedParams) => {
      track(META.name, {
        ...params,
        category: 'asset_details',
      });
    },
    [track],
  );

  return { trackAssetModeSwitched };
};
